import { Box, Card, Skeleton } from "@mui/material";

export const DisplayCampaignListLoading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        display: "grid",
        gridTemplateColumns: {
          xs: "100%",
          sm: "repeat(2, 1fr)",
          lg: "repeat(3, 1fr)",
          xl: "repeat(4, 1fr)",
        },
        gridTemplateRows: "auto",
        gap: 2,
      }}
    >
      <CardSkeleton keyName="skeleton-1" />
      <CardSkeleton keyName="skeleton-2" />
      <CardSkeleton keyName="skeleton-3" />
      <CardSkeleton keyName="skeleton-4" />
      <CardSkeleton keyName="skeleton-5" />
      <CardSkeleton keyName="skeleton-6" />
    </Box>
  );
};

export const CardSkeleton = ({ keyName }: { keyName: string }) => {
  return (
    <Card
      key={keyName}
      variant="outlined"
      sx={{ display: "flex", flexDirection: "column", justifyContent: "space-between", padding: 1 }}
    >
      <Skeleton sx={{ width: "100%", height: "70px" }} variant="text" />
      <Skeleton sx={{ width: "100%", height: "120px" }} variant="rectangular" />
      <Skeleton sx={{ width: "100%", height: "50px" }} variant="text" />
    </Card>
  );
};
